var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHangUp = function SvgHangUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#CC292D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14C15.4062 14 13.875 14.2344 12.4062 14.7031V17.7969C12.4062 18.2344 12.2188 18.5469 11.8438 18.7344C10.875 19.2031 9.98438 19.8125 9.17188 20.5625C8.98438 20.75 8.75 20.8438 8.46875 20.8438C8.1875 20.8438 7.95312 20.75 7.76562 20.5625L5.28125 18.0781C5.09375 17.8906 5 17.6562 5 17.375C5 17.0938 5.09375 16.8594 5.28125 16.6719C8.5625 13.5469 12.4688 11.9844 17 11.9844C21.5312 11.9844 25.4375 13.5469 28.7188 16.6719C28.9062 16.8594 29 17.0938 29 17.375C29 17.6562 28.9062 17.8906 28.7188 18.0781L26.2344 20.5625C26.0469 20.75 25.8125 20.8438 25.5312 20.8438C25.25 20.8438 25.0156 20.75 24.8281 20.5625C24.0469 19.8438 23.1562 19.2344 22.1562 18.7344C21.7812 18.5469 21.5938 18.25 21.5938 17.8438V14.75C20.125 14.25 18.5938 14 17 14Z",
    fill: "#F8F8F8"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHangUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HangUp.70d818b7.svg";
export { ForwardRef as ReactComponent };